import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isNewUiUser } from './access';
import { LandingPage } from './landing/LandingPage';
import { v2Path } from './nav';
import './newui.css';

/**
 * The site's front door at `/`.
 *
 * Until now FlashTools had no public marketing page: `/` sat behind
 * `ProtectedRoute` and bounced a signed-out visitor straight to the login form,
 * so the only thing the world could see was a password box. This mounts the v2
 * landing there instead. `/v2` still serves the same page — this is a second
 * entry point to it, not a move.
 *
 * Signed-in visitors are forwarded to where they actually work, allowlisted
 * accounts into the revamp and everyone else to v1, using the same predicate as
 * `AllowlistGate` and the login redirect so no two of them can disagree.
 *
 * The landing renders while auth is still resolving rather than holding a
 * spinner. It is fully static — no API call, no user data — so there is nothing
 * to leak and nothing to wait for, and the visitor this page exists for is the
 * signed-out one, who should never wait on a Firebase round trip to read
 * marketing copy. The cost is that a signed-in visitor who types the bare domain
 * may see the landing for a moment before the redirect lands.
 */
export const PublicLanding: React.FC = () => {
  const { user, loading, isAdminSession } = useAuth();

  if (!loading && (user || isAdminSession)) {
    return (
      <Navigate
        to={isNewUiUser(user?.email) ? v2Path('/notifications') : '/notifications'}
        replace
      />
    );
  }

  return <LandingPage />;
};

export default PublicLanding;
